/**
 * CRITICAL: ResizeObserver fix must be the absolute first thing that runs.
 * We wrap the constructor and add high-priority listeners to kill the 
 * "ResizeObserver loop limit exceeded" notification before it reaches the UI.
 */
if (typeof window !== 'undefined') {
  // 1. Engineering Fix: Break the loop by deferring callbacks
  const RO = window.ResizeObserver;
  if (RO) {
    window.ResizeObserver = class extends RO {
      constructor(callback: any) {
        super((entries, observer) => {
          // Using a combination of rAF and setTimeout to ensure we break the paint cycle
          window.requestAnimationFrame(() => {
            setTimeout(() => {
              if (Array.isArray(entries) && entries.length > 0) {
                callback(entries, observer);
              }
            }, 0);
          });
        });
      }
    };
  }

  // 2. Absolute Suppression Fix: Intercept and Kill the Error Event
  const isROError = (msg: any): boolean => {
    const message = typeof msg === 'string' ? msg : (msg?.message || msg?.reason?.message || '');
    return /ResizeObserver/i.test(String(message));
  };

  // Override console.error
  const originalError = console.error;
  console.error = (...args) => {
    if (args.some(isROError)) return;
    originalError.apply(console, args);
  };

  // Intercept Error Events (Capture Phase)
  const killEvent = (e: any) => {
    if (isROError(e.message) || isROError(e.reason) || isROError(e.error)) {
      e.stopImmediatePropagation();
      e.preventDefault();
      
      // Nuclear Option: Hide the CRA Error Overlay if it somehow triggered
      const overlay = document.getElementById('webpack-dev-server-client-overlay');
      if (overlay) overlay.style.display = 'none';
      const overlayDiv = document.getElementById('webpack-dev-server-client-overlay-div');
      if (overlayDiv) overlayDiv.style.display = 'none';
    }
  };

  window.addEventListener('error', killEvent, true);
  window.addEventListener('unhandledrejection', killEvent, true);
}

import React from 'react';
import { createRoot } from 'react-dom/client';
import SinglePage from './components/SinglePage';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import './index.css';

// --- React 19/18 Modern Root API ---

const container = document.getElementById('root');

if (!container) {
  throw new Error("Root element with ID 'root' not found in the document.");
}

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SinglePage />} />
        <Route path="/feed" element={<SinglePage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
